<template>
  <div class="interview-duration" ref="interviewDuration" :class="showHighlight && 'is-highlight'">
    <span class="label">{{ $t(`${i18nPrefix}.label.interviewDuration`) }}</span>
    <el-autocomplete
      v-model="durationHour"
      ref="hourInputRef"
      class="duration-input hour-input"
      popper-class="duration-popper"
      :fetch-suggestions="getHourSuggestions"
      @select="handleSelect"
      @focus="handleHourFocus(durationHour, $event)"
      @blur="handleInputBlur"
      @keyup.enter.native="handleInputEnter"
    >
      <template #suffix>
        <div class="suffix">
          <i class="el-icon-arrow-down suffix-icon" :class="hourInputFocus && 'is-focus'"></i>
        </div>
      </template>
    </el-autocomplete>
    <el-autocomplete
      v-model="durationMinute"
      ref="minuteInputRef"
      class="duration-input minute-input"
      popper-class="duration-popper"
      :fetch-suggestions="getMinuteSuggestions"
      @focus="handleMinuteFocus(durationMinute, $event)"
      @blur="handleInputBlur"
      @keyup.enter.native="handleInputEnter"
    >
      <template #suffix>
        <div class="suffix">
          <i class="el-icon-arrow-down suffix-icon" :class="minuteInputFocus && 'is-focus'"></i>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.applicantList',
      hourInputFocus: false,
      minuteInputFocus: false,
      showHighlight: false
    }
  },
  computed: {
    durationHour: {
      get () {
        let hour = null
        const newHour = parseInt(this.value.hour)
        if (_.isNaN(newHour)) {
          hour = null
        } else {
          hour = this.$t(`${this.i18nPrefix}.label.hours`, { hour: newHour })
        }
        return hour
      },
      set (value) {
        let hour = parseInt(value)
        if (_.isNaN(hour)) {
          hour = null
        }
        this.$emit('change', {
          ...this.value,
          hour: hour
        })
      }
    },
    durationMinute: {
      get () {
        let minute = null
        const newMinute = parseInt(this.value.minute)
        if (_.isNaN(newMinute) || newMinute >= 60) {
          minute = null
        } else {
          minute = this.$t(`${this.i18nPrefix}.label.minutes`, { minute: newMinute })
        }
        return minute
      },
      set (value) {
        let minute = parseInt(value)
        if (_.isNaN(minute)) {
          minute = null
        }
        this.$emit('change', {
          ...this.value,
          minute: minute
        })
      }
    },
    hourSuggestions () {
      return _.chain(0).range(4).map((hour) => {
        return {
          value: this.$t(`${this.i18nPrefix}.label.hours`, { hour: hour })
        }
      }).value()
    },
    minuteSuggestions () {
      return _.chain(0).range(60, 15).map((minute) => {
        return {
          value: this.$t(`${this.i18nPrefix}.label.minutes`, { minute: minute })
        }
      }).value()
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    getHourSuggestions (keyword, callback) {
      callback(this.hourSuggestions)
    },
    getMinuteSuggestions (keyword, callback) {
      callback(this.minuteSuggestions)
    },
    handleSelect () {
      this.hourInputFocus = false
    },
    handleHourFocus (hour, event) {
      this.hourInputFocus = true
      this.handleInputFocus(hour, event)
    },
    handleMinuteFocus (minute, event) {
      this.minuteInputFocus = true
      this.handleInputFocus(minute, event)
    },
    handleInputFocus (value, event) {
      if (!value) {
        return
      }
      const numberLength = value.split(' ')[0].length
      const el = event.target
      el.setSelectionRange(0, numberLength)
    },
    handleInputBlur () {
      this.hourInputFocus = false
      this.minuteInputFocus = false
    },
    handleInputEnter (event) {
      event.target.blur()
      this.$refs.hourInputRef.close()
      this.$refs.minuteInputRef.close()
    },
    scrollToCenterAndHighlight () {
      this.$refs.interviewDuration.scrollIntoView({ block: 'center', behavior: 'smooth' })
      this.showHighlight = true
      setTimeout(() => { this.showHighlight = false }, 3000)
    }
  }
}
</script>

<style scoped lang="scss">
.interview-duration {
  .label {
    font-size: 12px;
    color: #000;
    margin-right: 10px;
  }

  .duration-input {
    &.hour-input {
      width: 88px;
      margin-right: 10px;
    }

    &.minute-input {
      width: 112px;
    }

    .suffix {
      height: 100%;
      display: flex;
      align-items: center;

      .suffix-icon {
        transition: transform .3s;

        &.is-focus {
          transform: rotate(180deg);

        }
      }
    }

    ::v-deep {
      .el-input__inner {
        color: #000;
        height: 30px;
        padding-right: 0;
        padding-left: 8px;
      }

      .el-input__suffix-inner {
        pointer-events: none;
      }
    }
  }

  &.is-highlight {
    .duration-input {
      ::v-deep {
        .el-input__inner {
          box-shadow: 0 0 4px 0 rgba(0,150,204,0.3);
          border: 1px solid #0096cc;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.duration-popper {
  .el-autocomplete-suggestion__list {
    li {
      padding-left: 10px;
      padding-right: 0;
    }
  }
}
</style>
